import { Button, Input } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import type { CommentEditor } from '../../lib/hooks';
import styles from './CommentBlock.module.css';

interface CommentBlockProps {
  // Заголовок секции, напр. «Обоснование тегов».
  label: string;
  // Плейсхолдер поля ввода.
  placeholder: string;
  // Текущий текст; '' — обоснования нет.
  comment: string;
  // Кто последним правил: 'human' — вручную, 'auto' — ИИ. null без текста.
  origin: 'human' | 'auto' | null;
  // Может ли пользователь редактировать (гейтит вызывающий).
  editable: boolean;
  editor: CommentEditor;
}

// Единый блок обоснования с провенансом: показ, правка, снятие. Переиспользуется
// для обоснований тегов и категорий — отличаются лишь подписями и эндпоинтом.
export function CommentBlock({ label, placeholder, comment, origin, editable, editor }: CommentBlockProps) {
  // Нечего показать и нечего редактировать — секции нет.
  if (!comment && !editable) return null;

  if (editor.editing) {
    return (
      <div className={styles.block}>
        <div className={styles.label}>{label}</div>
        <Input.TextArea
          autoFocus
          value={editor.draft}
          onChange={(e) => editor.setDraft(e.target.value)}
          placeholder={placeholder}
          autoSize={{ minRows: 2, maxRows: 6 }}
        />
        <div className={styles.actions}>
          <Button size="small" onClick={editor.cancelEdit} disabled={editor.isSaving}>
            Отмена
          </Button>
          <Button type="primary" size="small" loading={editor.isSaving} onClick={editor.save}>
            Сохранить
          </Button>
        </div>
      </div>
    );
  }

  if (comment) {
    return (
      <div className={styles.block}>
        <div className={styles.head}>
          <span className={styles.label}>{label}</span>
          <span className={styles.origin}>
            {origin === 'human' ? 'отредактировано вручную' : 'сформировано ИИ'}
          </span>
          {editable && (
            <button type="button" className={styles.editBtn} onClick={editor.startEdit}>
              <EditOutlined /> Изменить
            </button>
          )}
        </div>
        <div className={styles.text}>{comment}</div>
      </div>
    );
  }

  // Текста нет, но пользователь — модератор: предлагаем добавить.
  return (
    <button type="button" className={styles.addBtn} onClick={editor.startEdit}>
      <PlusOutlined /> Добавить обоснование
    </button>
  );
}
